module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/497f797eeffe5fa7e6a626abc0db08a1.svg";